var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.685,
    height: 16.26,
    viewBox: "0 0 12.685 16.26",
    className: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M11.779,16.26H.906A.939.939,0,0,1,0,15.293V7.743a.939.939,0,0,1,.906-.968H1A.939.939,0,0,0,1.9,5.808v-.1c0-.252,0-.579,0-.911V4.742c0-.351,0-.7,0-.968a4.156,4.156,0,0,1,.555-1.887A4.276,4.276,0,0,1,6.343,0a4.275,4.275,0,0,1,3.884,1.887,4.157,4.157,0,0,1,.555,1.887V5.808a.939.939,0,0,0,.906.968h.091a.94.94,0,0,1,.907.968v7.55A.94.94,0,0,1,11.779,16.26ZM6.343,9.486a1.316,1.316,0,0,0-1.269,1.355v.5a2.726,2.726,0,0,1,.634,1.635v.285c0,.534.285.968.634.968s.634-.434.634-.968v-.285a2.729,2.729,0,0,1,.634-1.635v-.5A1.315,1.315,0,0,0,6.343,9.486Zm0-7.452a2.545,2.545,0,0,0-2.22.871,1.64,1.64,0,0,0-.317.871V5.808a.939.939,0,0,0,.906.968H7.973a.939.939,0,0,0,.906-.968V3.776A1.64,1.64,0,0,0,8.562,2.9,2.545,2.545,0,0,0,6.342,2.033Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2ea8b2f2b164b6d154a35d6dbc657e07.svg";
export { ForwardRef as ReactComponent };